<script>
import { makeLogger } from "@/shared/consola";
const logger = makeLogger("CreatorProductList.vue");
</script>

<script setup>
import cCreatorProductItem from "./cCreatorProductItem.vue";
import { CardEmpty, CardPreloader } from "@easy/ui/cards";
import { FormInputPreIcon } from "@easy/ui/forms";
import { ShippingBoxIcon } from "@easy/ui/icons";
import cPagination from "@/shared/components/cPagination.vue";
import { computed } from "vue";

const props = defineProps({
    items: { type: Array },
    isLoading: { type: Boolean, default: false },
    selected: { type: Number },
    totalPages: { type: Number },
});

defineEmits(["select", "addNewProduct"]);

const query = defineModel("query", { type: String, required: true });
const currentPage = defineModel("currentPage", { type: Number, required: true });
const selectedProduct = defineModel("selectedProduct", { type: Object });
const selectLater = defineModel("selectLater", { type: Boolean, required: true });

const emptyIcon = computed(() => ShippingBoxIcon);
const isEmpty = computed(() => !props.isLoading && props.items.length === 0);
const isEmptyWhenSearch = computed(
    () => !props.isLoading && props.items.length === 0 && Boolean(query.value)
);
logger.debug("Query", query.value, "is not currently used...");

const checkSelected = (p) => selectedProduct.value?.id === p.id;
</script>

<template>
    <div class="flex items-center justify-end space-x-2">
        <!--
            @remove
                https://linear.app/easytools/issue/EAS-2096/fixes-for-onboarding-questions-about-all-the-tools#comment-c52b5e4c

            <p class="text-base font-medium ct-text-1">
                {{ $t("shared.creator.products_list") }}
            </p>
        -->
        <FormInputPreIcon
            icon="MagnifyingGlassIcon"
            :placeholder="$t('shared.search')"
            v-model="query"
        />
    </div>
    <div class="space-y-3">
        <CardPreloader v-if="isLoading" />
        <template v-else>
            <cCreatorProductItem
                :item="{
                    name: $t('shared.creator.no_product'),
                    description: $t('shared.creator.no_product_details'),
                }"
                :isSelected="selectLater"
                @click="
                    selectedProduct = null;
                    selectLater = true;
                "
            />
            <cCreatorProductItem
                v-for="item in items"
                :key="item.id"
                :item="item"
                :isSelected="checkSelected(item)"
                @click="
                    selectedProduct = item;
                    selectLater = false;
                "
            />
        </template>
    </div>
    <CardEmpty
        class="w-full"
        v-if="isEmpty"
        :icon="emptyIcon"
        :title="
            isEmptyWhenSearch
                ? $t('shared.creator.empty_when_search', { query })
                : $t('shared.creator.products.empty_title')
        "
        :subtitle="$t('shared.creator.products.empty_subtitle')"
        :cta-label="$t('shared.creator.products.empty_cta')"
        @add="$emit('addNewProduct')"
    />
    <cPagination v-model="currentPage" :totalPages="totalPages" />
</template>
